var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_18044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9998 49.9999C99.9998 77.6141 77.6143 99.9999 49.9999 99.9999C22.3858 99.9999 1.04167e-05 77.6141 0 49.9999C-1.04167e-05 22.3858 22.3858 1.04167e-05 49.9999 0C77.614 -1.04167e-05 99.9998 22.3858 99.9998 49.9999Z",
    fill: "url(#paint0_linear_1101_18044)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 23C35.0883 23 23 35.0883 23 50C23 51.4634 23.1164 52.8997 23.3405 54.3C23.4887 55.256 24.0473 57.329 25.0963 57.9736C26.4055 58.778 27.8874 58.0865 29.1004 57.5204L29.1062 57.5177C30.0775 57.0644 32.9291 55.7352 34.2334 55.1272C34.5321 54.9786 35.3211 54.7793 36.0882 55.172C37.0471 55.6629 37.3287 56.6712 37.2716 57.2725C37.2145 57.8737 36.891 58.6675 36.0741 59.0461C35.4205 59.349 31.5742 61.1416 29.7327 62.0001C29.3375 62.1528 28.4625 62.7254 28.1237 63.7934C27.7003 65.1284 28.3605 66.1587 28.5918 66.4548C28.7645 66.6901 29.2794 67.2156 29.9569 67.4348C30.8037 67.7088 31.531 67.6042 32.0989 67.3451C32.5532 67.1379 41.5659 62.9345 46.0154 60.8588C46.3069 60.7142 47.0812 60.5254 47.8459 60.9271C48.8018 61.4292 49.0769 62.3754 49.0287 62.9595C48.9804 63.5437 48.6569 64.403 47.8604 64.7747C47.2231 65.0721 41.3038 67.8283 38.4238 69.1693C37.9159 69.3992 36.8853 70.2087 36.8251 71.608C36.7498 73.3572 37.9596 74.1863 38.466 74.4195C38.8657 74.6254 39.9171 74.9207 40.9252 74.4543C41.9333 73.9879 52.6462 68.9915 57.8766 66.5516C58.1868 66.3915 59.0298 66.1848 59.7484 66.5516C60.6897 67.0319 61.0023 67.8515 61.0023 68.4715C61.0023 69.0914 60.9742 69.5462 59.9934 70.4248C59.1355 71.1934 57.8766 71.9496 53.5869 73.7777C52.1177 74.4038 51.1165 74.8647 51.2812 75.6552C51.405 76.2492 51.8374 76.4752 53.2739 76.4102C54.7105 76.3452 61.1791 75.8375 67.6593 70.4248C73.3804 65.4739 77 58.1597 77 50C77 46.9933 76.5085 44.1013 75.6015 41.4001C75.2933 41.5289 74.9549 41.6 74.6 41.6C73.1641 41.6 72 40.4359 72 39C72 37.9664 72.6031 37.0737 73.4766 36.6546C68.8306 28.4991 60.0575 23 50 23ZM60 40C60 41.4359 58.8359 42.6 57.4 42.6C55.9641 42.6 54.8 41.4359 54.8 40C54.8 38.5641 55.9641 37.4 57.4 37.4C58.8359 37.4 60 38.5641 60 40Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1101_18044",
    x1: 49.9999,
    y1: 0,
    x2: 49.9999,
    y2: 99.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6246F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493007,
    stopColor: "#5166EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56B9F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_18044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkto);
export default __webpack_public_path__ + "static/media/okto.bbf588dd53b2e55f39191a313272a1b8.svg";
export { ForwardRef as ReactComponent };